import * as React from 'react';
import * as _ from "lodash";
import { breakpoints, useThemePart } from '..';
export function useBreakpointCheck(breakpoint, check) {
    var bps = Object.keys(breakpoints);
    var currentScreenBreakPoint = useThemePart(function (t) { return t === null || t === void 0 ? void 0 : t.currentScreenBreakPoint; });
    return React.useMemo(function () {
        var i1 = _.findIndex(bps, function (k) { return k === currentScreenBreakPoint; });
        var i2 = _.findIndex(bps, function (k) { return k === breakpoint; });
        return check(i1, i2);
    }, [check, breakpoint, currentScreenBreakPoint]);
}
export function useBelowBreakpointOrEqual(breakpoint) {
    return useBreakpointCheck(breakpoint, function (l, r) { return l <= r; });
}
export function useBelowBreakpoint(breakpoint) {
    return useBreakpointCheck(breakpoint, function (l, r) { return l < r; });
}
export function useAboveBreakpointOrEqual(breakpoint) {
    return useBreakpointCheck(breakpoint, function (l, r) { return l >= r; });
}
export function useAboveBreakpoint(breakpoint) {
    return useBreakpointCheck(breakpoint, function (l, r) { return l > r; });
}
var checkMethod = function (currentScreenBreakPoint, check, breakpoint) {
    var bps = Object.keys(breakpoints);
    var i1 = _.findIndex(bps, function (k) { return k === currentScreenBreakPoint; });
    var i2 = _.findIndex(bps, function (k) { return k === breakpoint; });
    return check(i1, i2);
};
export function useBreakpointChecks(checks) {
    var currentScreenBreakPoint = useThemePart(function (t) { return t.currentScreenBreakPoint; });
    var _a = React.useState(_.clone(checks)), innerChecks = _a[0], setInnerChecks = _a[1];
    React.useEffect(function () { return setInnerChecks(function (c) { return _.isEqual(c, checks) ? c : checks; }); }, [checks]);
    var toRet = React.useMemo(function () {
        return _.map(innerChecks, function (check) {
            switch (check.type) {
                case "below":
                    return checkMethod(currentScreenBreakPoint, function (l, r) { return l < r; }, check.breakpoint);
                case "belowOrEqual":
                    return checkMethod(currentScreenBreakPoint, function (l, r) { return l <= r; }, check.breakpoint);
                case "above":
                    return checkMethod(currentScreenBreakPoint, function (l, r) { return l > r; }, check.breakpoint);
                case "aboveOrEqual":
                    return checkMethod(currentScreenBreakPoint, function (l, r) { return l >= r; }, check.breakpoint);
            }
        });
    }, [currentScreenBreakPoint, innerChecks]);
    return toRet;
}
//# sourceMappingURL=BreakpointHelpers.js.map